/*eslint-disable*/

import React, { useState, useEffect } from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import PersonalDetails from "../../components/LayoutComponents/PersonalDetails/PersonalDetails";
import { Box, IconButton, Typography, Skeleton } from "@mui/material";
import { HiArrowLeft } from "react-icons/hi";
import UserAvatar from "../../components/UserAvatar/UserAvatar";
import { useNavigate } from "react-router-dom"; // Import useNavigate hook

import messages_en from "./translations/en.json";
import messages_pt from "./translations/pt.json";
import messages_fr from "./translations/fr.json";

import OfflineMessage from "../../components/offline_message";

const messages = {
    en: messages_en,
    pt: messages_pt,
    fr: messages_fr,
};

import FastAPIClient from "../../client";
import config from "../../config";

const client = new FastAPIClient(config);

const useNetworkStatus = () => {
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    const [isSlowConnection, setIsSlowConnection] = useState(false);

    useEffect(() => {
        const handleOnline = () => setIsOnline(true);
        const handleOffline = () => setIsOnline(false);

        const handleConnectionChange = () => {
            const connection =
                navigator.connection ||
                navigator.mozConnection ||
                navigator.webkitConnection;
            if (connection) {
                setIsSlowConnection(
                    connection.effectiveType === "2g" ||
                        connection.effectiveType === "3g" ||
                        connection.downlink < 1.5
                );
            }
        };

        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);

        if (navigator.connection) {
            handleConnectionChange();
            navigator.connection.addEventListener(
                "change",
                handleConnectionChange
            );
        }

        return () => {
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);

            if (navigator.connection) {
                navigator.connection.removeEventListener(
                    "change",
                    handleConnectionChange
                );
            }
        };
    }, []);

    return { isOnline, isSlowConnection };
};

const Settings = () => {
    const [user, setUser] = useState(null); // Initially null instead of false
    const [loading, setLoading] = useState(true); // State to track if the data is loading
    const navigate = useNavigate(); // Hook to get the navigate function
    const locale = "fr"; // State for locale

    const { isOnline, isSlowConnection } = useNetworkStatus();

    useEffect(() => {
        getUser();
    }, []);

    const getUser = () => {
        client.fetchUser().then((data) => {
            setUser(data);
            setLoading(false); // Once data is fetched, set loading to false
        });
    };

    const handleSave = (updatedUser) => {
        // Call API to save user details (example)
        // client.updateUser(updatedUser).then(() => {
        //   setUser(updatedUser);
        // });
    };

    if (!isOnline) {
        return <OfflineMessage />;
    }
    if (isOnline) {
        return (
            <IntlProvider locale={locale} messages={messages[locale]}>
                <section
                    className="flex flex-col text-center bg-white pl-5 pr-5 md:pl-0 md:pr-0  md:w-3/4 md:ml-10"
                    style={{ minHeight: "100vh" }}
                >
                    <Box className="flex justify-start w-full mt-10 -ml-2 block md:hidden">
                        <IconButton
                            onClick={() => navigate(-1)} // This will go back to the previous page
                            sx={{ color: "black", fontSize: "18px" }} // Set the icon color to white for better contrast
                        >
                            <HiArrowLeft />
                        </IconButton>
                    </Box>

                    {/* Conditional rendering for Skeleton loader */}
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        className="w-full md:w-1/2 mt-2 md:mt-20" // Full width below md, 50% width at md and above
                        mb={2}
                    >
                        <Typography
                            variant="h4" // Use the MUI variant for the desired size
                            sx={{
                                fontWeight: "bold", // Apply bold styling
                                textAlign: "left", // Align the text to the left
                            }}
                        >
                            {loading ? (
                                <Skeleton width="150px" />
                            ) : (
                                <FormattedMessage
                                    id="editProfile"
                                    defaultMessage="Edit profile"
                                />
                            )}
                        </Typography>

                        {loading ? (
                            <Skeleton
                                variant="circular"
                                width={40}
                                height={40}
                            />
                        ) : (
                            <UserAvatar
                                user={user}
                                width={{ sm: 40, md: 50, lg: 60 }}
                                height={{ sm: 40, md: 50, lg: 60 }}
                            />
                        )}
                    </Box>

                    {/* Show skeletons for PersonalDetails section while loading */}
                    <div className="md:mt-10">
                        {loading ? (
                            <div>
                                <Skeleton
                                    variant="rounded"
                                    width="60%"
                                    className="mt-5"
                                />
                                <Skeleton
                                    variant="rounded"
                                    width="60%"
                                    className="mt-5"
                                />
                                <Skeleton
                                    variant="rounded"
                                    width="60%"
                                    className="mt-5"
                                />
                            </div>
                        ) : (
                            user.first_name && <PersonalDetails user={user} />
                        )}
                    </div>

                    {/* Language Switcher */}
                </section>
            </IntlProvider>
        );
    }
};

export default Settings;
